<div class="wrapper">
  <mat-card class="card">
    <img
      class="logo"
      style="cursor: pointer;"
      routerLink="/"
      src="https://streavent-prod-streavent-public-1606489092187.s3.eu-central-1.amazonaws.com/1606683595881-fetch.png"
    />
    <span class="headline">Setze ein neues Passwort.</span>
    <span class="text">Vergeben Sie ein neues sicheres Passwort, mit dem Sie sich dann anmelden können.</span>
    <form class="marginTop" [formGroup]="resetPwForm">
      <span class="label">NEUES PASSWORT</span>

      <mat-form-field
        class="form-field"
        [class.error]="
          resetPwForm.get('newPassword')?.touched &&
          (resetPwForm.get('newPassword')?.hasError('pattern') || resetPwForm.get('newPassword')?.hasError('minlength'))
        "
        appearance="outline"
      >
        <input
          matInput
          placeholder="Passwort"
          formControlName="newPassword"
          [type]="hideNewPw ? 'password' : 'text'"
          class="form-control"
          required
        />
        <span
          class="hidePwButton"
          mat-icon-button
          matSuffix
          (click)="hideNewPw = !hideNewPw"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hideNewPw"
        >
          <mat-icon>{{ hideNewPw ? 'visibility' : 'visibility_off' }}</mat-icon>
        </span>
        <mat-error
          style="margin-bottom: 15px;"
          *ngIf="
            resetPwForm.get('newPassword')?.touched &&
            (resetPwForm.get('newPassword')?.hasError('pattern') || resetPwForm.get('newPassword')?.hasError('minlength'))
          "
          >Das Passwort muss mindestens 12 Zeichen lang sein und aus mindestens einem Groß- und Kleinbuchstaben und einer Zahl bestehen.
        </mat-error>
      </mat-form-field>
      <span class="label">WIEDERHOLE NEUES PASSWORT</span>
      <mat-form-field class="form-field" appearance="outline">
        <input
          matInput
          placeholder="Passwort"
          formControlName="newPasswordRepeat"
          [type]="hidePwRepeat ? 'password' : 'text'"
          class="form-control"
          required
        />
        <span
          class="hidePwButton"
          mat-icon-button
          matSuffix
          (click)="hidePwRepeat = !hidePwRepeat"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hidePwRepeat"
        >
          <mat-icon>{{ hidePwRepeat ? 'visibility' : 'visibility_off' }}</mat-icon>
        </span>
      </mat-form-field>
      <mat-error
        style="margin-bottom: 15px;"
        *ngIf="
          resetPwForm?.errors?.passwordsMustMatch &&
          (resetPwForm.get('newPasswordRepeat')?.touched || resetPwForm.get('newPasswordRepeat')?.dirty)
        "
        >Die neuen Passwörter müssen übereinstimmen</mat-error
      >
      <button class="saveButton" mat-flat-button [disabled]="resetPwForm.invalid" [class.correct]="resetPwForm.valid" (click)="resetPw()">
        PASSWORT ZURÜCKSETZEN
      </button>
    </form>
    <div class="row marginTop">
      <a class="questionButton" href="mailto:event@streavent.de"> Brauchen Sie Hilfe? </a>
    </div>
  </mat-card>
</div>
